module.exports = __webpack_public_path__ + "static/ShareFile-c3e84da9b9d90f84526ef93cc5343629.png";